import { render, staticRenderFns } from "./SelectYear.vue?vue&type=template&id=1b0bbf1e&scoped=true"
import script from "./SelectYear.vue?vue&type=script&lang=js"
export * from "./SelectYear.vue?vue&type=script&lang=js"
import style0 from "./SelectYear.vue?vue&type=style&index=0&id=1b0bbf1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0bbf1e",
  null
  
)

export default component.exports